import React, { useEffect } from "react";
import { Table  } from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { connect } from "react-redux";
import TrainingModuleForm from "./TrainingModuleForm";
import PopupButton from "components/button/PopupButton";
import { handleTableChange } from "../../../../utils/index";
import { 
	getTrainingModuleList, 
	doTrainingModuleDelete,
	doTrainingModuleReset,
} from "../../../../redux/trainingmodule/trainingModuleState";
import { STAFF_STATUS_COLORS } from "variables/constants";
import Badge from "components/badge";
import SearchFilter from "components/search/SearchFilter";
import { useCRUDAccess } from "utils/useCRUDAccess";
import {MODULE_TRAINING_MOD} from "variables/constants"


const TrainingModuleTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters, 
	doDelete,
	doRecordReset
}) => {
	const checkCRUDAccess = useCRUDAccess();
	const accessRights = checkCRUDAccess(MODULE_TRAINING_MOD, ['view', 'add', 'edit', 'delete'], true);
	


  	const columns = [
		{
	        title: `Title`,
	        dataIndex: 'trm_title',
	        key: 'trm_title',
	        width: '45%',
	        render:(trm_title) => <span>{trm_title}</span> 
	    },
		{
	        title: `Question Items`,
	        dataIndex: 'trm_question_items',
	        key: 'trm_question_items',
	        width: '12%',
	        render:(trm_question_items) => <span>{trm_question_items}</span> 
	    },
		{
	        title: `Passing Score`,
	        dataIndex: 'trm_passing_score',
	        key: 'trm_passing_score',
	        width: '12%',
	        render:(trm_passing_score) => <span>{trm_passing_score}</span> 
	    },
		{
	        title: `Status`,
	        dataIndex: 'trm_status_name',
	        key: 'trm_status_name',
	        width: '6%',
	        render:(trm_status_name) => (
				<Badge color={STAFF_STATUS_COLORS[trm_status_name]}>
					<span>{trm_status_name}</span>
				</Badge>
			)
	    },
		{
			title: 'Client',
			dataIndex: 'client_name',
			key: 'client_name',
			width: '25%',
			render:(client_name) => <span>{client_name}</span> 
		},
		
	    {
	        title: <PopupButton id="add_trainingModule" title="Add Training Module" label="Add" btnClass="btn-small" action="add" moduleId={MODULE_TRAINING_MOD}>
						<TrainingModuleForm recordId="0" mode="edit" />
					</PopupButton>,
	        dataIndex: 'trm_id',
	        key: 'trm_id',
	        width: '12%',
	        render:(_, record) => <CrudOption 
									baseRoute="/console/training-modules" 
									recordId={record?.trm_id} 
									deleteHandler={doDelete}
									allowEdit={accessRights.edit}
									allowDelete={accessRights.delete}
									editMode="modal"
									title="Edit Training Module"
									closeHandler={doRecordReset}
									editHandler={(recordId, doRecordReset ) => (
										<TrainingModuleForm 
											recordId={recordId} 
											mode="edit" 
											onCancel={doRecordReset} 
										/>
									)}
								/>
	    },
    ];
    
	useEffect(() => {
		doSearch({paginate: pagination.per_page});
	}, [doSearch, pagination.per_page]);
	
  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      	
			<SearchFilter placeholder="Search by Title or Client name" searchHandler={doSearch} filters={filters} pagination={pagination}/>
				<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.trm_id}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
					onChange={handleTableChange(doSearch, filters)}                	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.trainingModule.trainingModuleList?.items,
	pagination: state.trainingModule.trainingModuleList?.pagination,
	filters: state.trainingModule.trainingModuleList?.filters,
	requesting: state.trainingModule.trainingModuleList?.requesting,
	error: state.trainingModule.trainingModuleList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getTrainingModuleList(filters)),
	doDelete: (id) => dispatch(doTrainingModuleDelete(id)),
	doRecordReset: () => dispatch(doTrainingModuleReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingModuleTable);
